<template>
  <div id="app_dashboard_admin">
    <REPORTCARDCOMPONENT
      @filterDateRange="changeDateFn"
      @ClearfilterDateRange="getDashboardDetails"
    />
    <TOPSELLINGPRODUCTS :dashboardData="dashboardData" />
    <salesAndCollectionAnalysis :dashboardData="dashboardData" :filterFromDate="currentFromDate" :filterToDate="currentToDate" />
    <outletMap :dashboardData="dashboardData" />
  </div>
</template>

<script>
import REPORTCARDCOMPONENT from "@/components/MAIN_DASHBOARD/report_card_component.vue";
import TOPSELLINGPRODUCTS from "@/components/MAIN_DASHBOARD/top_selling_products.vue";
import salesAndCollectionAnalysis from "@/components/MAIN_DASHBOARD/sales_and_collection_analysis.vue";
import outletMap from "@/components/MAIN_DASHBOARD/outlet_map.vue";
import axios from 'axios';

export default {
  name: 'MainDashboard',
  
  components: {
    REPORTCARDCOMPONENT,
    TOPSELLINGPRODUCTS,
    salesAndCollectionAnalysis,
    outletMap,
  },

  data() {
    return {
      dashboardData: null,
      userId: null,
      defaultFromDate: null,
      defaultToDate: null,
      currentFromDate: null,
      currentToDate: null,
    };
  },

  created() {
    this.userId = localStorage.getItem('userId');
    
    // Set default date range (last 30 days)
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    
    this.defaultToDate = today.toISOString().split('T')[0];
    this.defaultFromDate = thirtyDaysAgo.toISOString().split('T')[0];
    
    this.currentToDate = this.defaultToDate;
    this.currentFromDate = this.defaultFromDate;
    
    this.getDashboardDetails();
  },

  methods: {
    changeDateFn(e) {
      if (e && e.start && e.end) {
        this.currentFromDate = e.start;
        this.currentToDate = e.end;
        this.fetchDashboardData(this.userId, e.start, e.end);
      }
    },

    getDashboardDetails() {
      this.currentFromDate = this.defaultFromDate;
      this.currentToDate = this.defaultToDate;
      this.fetchDashboardData(this.userId, this.defaultFromDate, this.defaultToDate);
    },

    fetchDashboardData(userId, fromDate, toDate) {
      if (!fromDate || !toDate) return;
      
      const token = localStorage.getItem("token");
      const baseUrl = process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_API_BASE_URL;
      const url = `${baseUrl}/api/dashboard/piyestra?userId=${userId}&fromDate=${fromDate}&toDate=${toDate}`;

      axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.data.success) {
          this.dashboardData = response.data.data;
          this.$store.dispatch('updateDashboardDetails', {
            rawData: response.data.data
          });
        }
      })
      .catch(error => {
        console.error('Error fetching dashboard data:', error);
      });
    }
  }
}
</script>

<style>
@import "../../styles/dashboard/dashboard.scss";
</style>